import React, { useState } from 'react';
import api from '../services/api';
import { useParams, useNavigate, Link } from 'react-router-dom';
import '../styles/auth.css';

const ResetPassword = () => {
  const [senha, setSenha] = useState('');
  const [confirmSenha, setConfirmSenha] = useState('');
  const [message, setMessage] = useState('');
  const { token } = useParams();
  const navigate = useNavigate();

  const handleResetPassword = async () => {
    if (senha !== confirmSenha) {
      setMessage('As senhas não coincidem.');
      return;
    }

    try {
      const response = await api.post(`/auth/reset-password/${token}`, { senha });
      setMessage(response.data.message || 'Senha redefinida com sucesso.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage(error.response?.data?.error || 'Erro ao redefinir a senha.');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Redefinir senha</h2>
        <div className="form-group">
          <input
            type="password"
            placeholder="Nova Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Confirmar Nova Senha"
            value={confirmSenha}
            onChange={(e) => setConfirmSenha(e.target.value)}
          />
        </div>
        <button onClick={handleResetPassword}>
          Redefinir senha
        </button>
        <div className="login-link">
          <Link to="/login">Voltar para o login</Link>
        </div>
        {message && <p className="auth-message" style={{ color: message.includes('sucesso') ? 'green' : 'red' }}>{message}</p>}
      </div>
    </div>
  );
};

export default ResetPassword;
